import { Middleware, MiddlewareAPI, Dispatch, AnyAction } from 'redux'
import { ApplicationState } from 'store'
import { UserMessagingActionTypes, USER_JOINED, USER_EDIT, USER_READONLY, SESSION_ENDED, CHANNEL_REFRESH } from './types'
import { makeVNCConnection } from 'modules/Vnc'
import { endConnection, getUsers } from 'store/session'

const READ_MESSAGE = 'REDUX_WEBSOCKET::MESSAGE'

export const userMessaging = (): Middleware => {
	const user: Middleware =
		({ dispatch, getState }: MiddlewareAPI<Dispatch<AnyAction>, ApplicationState>) =>
		(next: Dispatch) =>
		async (action: AnyAction): Promise<AnyAction> => {
			switch (action.type) {
				case READ_MESSAGE: {
					const message: UserMessagingActionTypes = JSON.parse(action.payload.message)
					const state = getState()
					switch (message.type) {
						case USER_JOINED:
						case CHANNEL_REFRESH: {
							if (state.session.isAdmin) {
								await getUsers(true)(dispatch, getState, null)
							}
							return next(action)
						}
						case USER_EDIT: {
							await makeVNCConnection(true, state.session.username, state.session.password, message.payload.userId)
							break
						}
						case USER_READONLY: {
							await makeVNCConnection(false, state.session.username, state.session.password, message.payload.userId)
							break
						}
						case SESSION_ENDED: {
							await next(endConnection())
							break
						}
					}
					return next(action)
				}
				default: {
					return next(action)
				}
			}
		}

	return user
}
